import Checkbox from "@mui/material/Checkbox";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { GetPersonalFavoriteListResponse } from "api/generatedApi";

interface Props {
  row: GetPersonalFavoriteListResponse;
  onCheck?: (id: string | undefined) => void;
  checked?: boolean;
  setChoosenList: (id: string) => void;
}

export const DesktopListRow = (props: Props) => {
  const { row, onCheck, checked } = props;

  return (
    <TableRow data-testid={`account-favorite-row-${row.name}`}>
      <TableCell>
        <Checkbox data-testid="account-favorite-row-checkbox" onChange={() => onCheck?.(row.id)} onClick={(event) => event.stopPropagation()} checked={checked} />
      </TableCell>
      <TableCell data-testid="account-favorite-row-text" title={row.name ?? ""} onClick={() => props.setChoosenList(row.id ?? "")} sx={{ cursor: "pointer" }}>
        <Typography variant="body2">{row.name}</Typography>
      </TableCell>
    </TableRow>
  );
};
